/**
 * ==============================================================================
 * DATA LAYER (DL): Comunicación directa con la API
 * ==============================================================================
 */

// Obtener el listado de canciones
const GetSongs = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}karaoke/songs`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      const errorData = await response.json()
      return { success: false, message: errorData.message || 'Error al obtener canciones.' }
    }

    const data = await response.json()
    // La API devuelve { songs: [...] }
    return { success: true, data: data.songs }
  } catch (error) {
    return { success: false, message: 'Error de conexión al obtener canciones.' }
  }
}

// Guardar (Crear o Editar) una canción
const SaveSong = async (songData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}karaoke/songs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(songData)
    })

    if (!response.ok) {
      const errorData = await response.json()
      return { success: false, message: errorData.message || 'Error al guardar la canción.' }
    }

    const data = await response.json()
    return { success: true, data: data }
  } catch (error) {
    return { success: false, message: 'Error de conexión al guardar la canción.' }
  }
}

// Eliminar una canción
const DeleteSong = async (songId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}karaoke/songs/${songId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      const errorData = await response.json()
      return { success: false, message: errorData.message || 'Error al eliminar la canción.' }
    }

    return { success: true, data: null }
  } catch (error) {
    return { success: false, message: 'Error de conexión al eliminar la canción.' }
  }
}

const SendKaraokeCamConfig = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}karaoke/cam-overlay-config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });

        if (!response.ok) {
            return { success: false, message: 'Error al actualizar el Overlay de Karaoke Cam' };
        }
        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

export { GetSongs, SaveSong, DeleteSong, SendKaraokeCamConfig };









// const GetSongs = async() => {
//     try {
//         // const dataToSend = {
//         //     id: id
//         // }

//         const response = await fetch(`${process.env.REACT_APP_API_URL}karaoke/songs`, {
//             //method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             }
//             //body: JSON.stringify(dataToSend)
//         })
        
//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
//             return { success: false, message: errorData.message || 'No ha sido posible obtener el listado de canciones. Actualiza la página o intenta actualizarla más tarde.' }
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener el listado de canciones. Intenta actualizar la página o inténtalo más tarde.' }
//     }
// }

// export { GetSongs };